import React from 'react';
import { Button } from 'antd';
import logoIcon from 'assets/img/login-elsa-logo-icon.svg';
import logoWordmark from 'assets/img/login-elsa-logo-wordmark.svg';
import './login.css';
import { useTranslation } from 'react-i18next';
import GlobalStore from 'stores/globalStore';
import { Helmet } from 'react-helmet';
import { getUniversalLoginUrl } from 'utils/universal-login';

const Signup: React.FC = () => {
  const { t } = useTranslation();
  const { currentLanguage } = GlobalStore.useContainer();

  return (
    <div className="signin-container">
      {currentLanguage === 'ja' ? (<Helmet>
        <title>新規登録 | ELSA Speak</title>
        <meta
          name="description"
          content="メールアドレスまたは Facebook で ELSA Speak のアカウントを作成できます。ELSA Speak の多彩な学習プログラムで、正しい発音と流暢な英会話を身につけましょう。"
        />
      </Helmet>) :
      <Helmet>
        <title>Signup Account - ELSA Speak</title>
        <meta
          name="description"
          content="ELSA Speak App new account signup for web PC. Login my account. Redeem ELSA Premium, Oxford Business Result, ELSA for Students, free."
        />
      </Helmet>}
      <div className="logo">
        <div className="logo-mark">
          <img className="logo-mark-icon" alt="logo" src={logoIcon} />
          <img className="logo-mark-wordmark" alt="" src={logoWordmark} />
        </div>
      </div>
      <div className="form-container">
        <h1 className="login-title login-title--signup">{t('signup.page_title')}</h1>
        <Button
          className="submit-button"
          onClick={() => {
            window.location.href = getUniversalLoginUrl();
          }}
        >
          {t('signup.signup')}
        </Button>
        <div className="form-login-footer">
          <span></span>
          <a href={getUniversalLoginUrl()}>
            <button className="footer-link">
              {t('login.login')}
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Signup;
